export class InsurerDashboardCounters {
    constructor() {
        this.approvalRequiredPoolTasks = 0;
    }
}
